import React, { useState } from "react";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import {
  Trademark_Registration,
  Trademark_Registration_v2,
  Trademark_Registration_v3,
  TradeMark_details_of_shareholder,
  TradeMark_upload_details,
  trademark_shareholder,
} from "./TrademarkRegistrationForm";
import { v4 as uuidv4 } from "uuid";
import FormPayment from "../../../../components/common/forms/FormPayment";

import axios from "axios";
import { useForm } from "react-hook-form";
import Documents from "../../../../components/common/forms/Documents";
import api from "../../../../api/api";
import { toast } from "react-toastify";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import BackButton from "../../../../components/common/backbutton/BackButton";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";

const TradeMarkRegistration = () => {
  const { register, handleSubmit, unregister } = useForm();
  const [shareHolders, setShareHolders] = useState([
    {
      ...trademark_shareholder,
      id: uuidv4(),
    },
  ]);

  const [docsOutput, setDocsOutput] = useState([]);
  const [fieldChange, setFieldChange] = useState(true);
  const [uploadProof, setUploadProof] = useState("");

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);
  const [paymentRangeList, setPaymentList] = useState([]);
  const [amount, setAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);

  // For amount calculation
  useEffect(() => {
    if (amount > 0) {
      let arr = paymentRangeList.filter((item) => {
        return (
          amount >= parseInt(item.range_start) &&
          amount <= parseInt(item.range_end)
        );
      });
      console.log(arr);

      arr.length > 0 && setTotalAmount(arr[0]?.amount);
    } else {
      setTotalAmount(0);
    }
  }, [amount, paymentRangeList]);

  // getting current user
  useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => {});
  }, []);

  // for filtering by company_type and show in Modal
  useEffect(() => {
    api
      .get(
        "/services/company/registration/service-charges/?company_type=trademark"
      )
      .then((response) => {
        // console.log(response.data)
        setPaymentList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // while changing type setting amount 0
  useEffect(() => {
    setAmount(0);
  }, [fieldChange]);

  useEffect(() => {
    if (fieldChange) {
      Trademark_Registration_v3.map((item) => {
        unregister(item.name);
      });
    } else {
      Trademark_Registration_v2.map((item) => {
        unregister(item.name);
      });
    }
  }, [unregister, fieldChange]);

  let data = [];
  TradeMark_upload_details.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  const handleClick = (data) => {
    data.company_type = "trademark";
    data.share_holders = shareHolders;
    data.documents = docsOutput;

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/company/", data)
      .then((response) => {
        toast.success("Data Registered successfully");

        let transactions = {

          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit",
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        //  console.log("error",error)
        toast.error("Data Registration Failed");
      });
  };
  const ekal = () => {
    setFieldChange(true);
  };
  const bahul = () => {
    setFieldChange(false);
  };

  return (
    <div>
      <form className="px-10 lg:!px-14">
        <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
          Trademark (Brand) Registration Form(ट्रेडमार्क दर्ता गर्नको लागि)
        </p>

        <div className="mt-3">
          {(user?.user_type === "ST" || user?.user_type === "AD") && (
            <AdminSearchCustomer setUserId={setUserId} />
          )}
        </div>

        <p className="text-primary-blue font-Calistoga text-lg my-5 underline">
          1. Company Name & Other Details
        </p>
        <CompanySearch register={register} />

        <div className=" my-5">
          <div>
            <div>
              <div className=" grid md:grid-cols-2 grid-cols-1 font-Laila border-2 border-primary-blue   w-full">
                <div className="border-primary-blue text-primary-red md:border-r-2 md:border-b p-2 text-center  text-lg font-bold">
                  कम्पनीको नाम
                </div>

                <div className="border-primary-blue w-full flex text-primary-red border-t md:border-b md:border-t-0 p-2 text-base font-bold sm:text-lg">
                  <p>नेपालीमा</p>
                  <input
                    className="text-primary-blue pl-3  w-[180px] md:w-full  outline-none"
                    {...register(`company_name_nep`, {
                      // required: false,
                    })}
                  />
                </div>
                {/* <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
                  <p>English मा : </p>
                  <input {...register(`company_name`, {
                    // required: false,
                  })} />
                </div> */}

                <div className="border-primary-blue border-t md:border-0 md:border-b text-primary-red  md:border-r-2  text-center p-2 text-lg font-bold">
                  कम्पनीको ठेगाना :
                </div>
                <div className="border-primary-blue border-t md:border-t-0 md:border-b text-primary-red border-t md:border-t-0  p-2 text-base font-bold sm:text-lg">
                  <input
                    className="text-primary-blue pl-3 w-full outline-none"
                    {...register(`company_address`, {
                      // required: false,
                    })}
                  />
                </div>

                <div className="border-primary-blue text-primary-red border-t md:border-t-0 p-2 md:border-r-2 border-0 text-center  text-lg font-bold">
                  ब्यवसायको प्रकार
                </div>
                <div className="w-full flex md:flex-row flex-col md:justify-center items-center border-primary-blue items-center gap-2 ">
                  {/* <div className="flex border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-base"> */}
                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full px-2  text-white">
                    <label htmlFor="ekal">एकल </label>
                    <input
                      type="radio"
                      name="radio-btn"
                      id="ekal"
                      defaultChecked
                      value="ekal"
                      onClick={ekal}
                      {...register("business_type", { required: false })}
                    />
                  </div>
                  <div className="border-primary-blue px-2 bg-primary-red flex items-center justify-center gap-1 rounded-full border  text-white">
                    <label htmlFor="bahul"> साझेदारी</label>
                    <input
                      type="radio"
                      name="radio-btn"
                      id="bahul"
                      value="bahul"
                      onClick={bahul}
                      {...register("business_type", { required: false })}
                    />
                  </div>
                  {/* <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border  text-white">
                    <label htmlFor="prali"> प्रा.लि. कम्पनी</label>
                    <input type="radio" name="radio-btn" id="prali" />
                  </div> */}
                  <div className="border-primary-blue px-2  bg-primary-red flex items-center justify-center gap-1 rounded-full border  text-white">
                    <label htmlFor="prali"> प्रा.लि. कम्पनी</label>
                    <input
                      type="radio"
                      name="radio-btn"
                      onClick={bahul}
                      id="prali"
                      value="prali"
                      {...register("business_type", { required: false })}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex md:flex-row font-Laila border-primary-blue flex-col items-center gap-2">
          {fieldChange === true ? (
            <>
              <div className="mt-4 border-2 border-primary-blue md:w-[60rem]">
                <div>
                  {Trademark_Registration_v2.map((item, i) => {
                    const { name, validation, ip1, type } = item;
                    return (
                      <div
                        key={i}
                        className="border-primary-blue flex ite w-full flex-col md:flex-row"
                      >
                        {/* <div className="border-primary-blue border grid grid-cols-2" key={i}> */}
                        <div className="border-primary-blue text-primary-red border-r-2 border-b md:w-[50%] text-center p-2 text-lg font-bold">
                          {ip1}
                        </div>
                        <div className="border-primary-blue text-primary-red border-b  w-full  text-lg font-bold">
                          <input
                            type={type}
                            className="text-primary-blue w-full   p-2 outline-none "
                            {...register(`${name}`, {
                              required: false,
                              onChange: (e) => {
                                e.target.name === "total_capital" &&
                                  setAmount(e.target.value);
                              },
                            })}
                          />
                        </div>
                      </div>
                    );
                  })}
                  <div>
                    <div className="text-center border-t border-primary-blue p-2 font-bold text-primary-blue border-t-0 bg-red-200">
                      ट्रेडमार्क (ब्राण्ड) दर्ताको लागि तपाईको जम्मा लाग्ने रकम{" "}
                      <span className="text-red-500">रु.{totalAmount}।– </span> मात्र
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className="mt-4 border-2 border-primary-blue md:w-[60rem]">
                <div>
                  {Trademark_Registration_v3.map((item, i) => {
                    const { name, validation, ip1, type } = item;
                    return (
                      <div
                        key={i}
                        className="border-primary-blue flex ite w-full flex-col md:flex-row"
                      >
                        {/* <div className="border-primary-blue border grid grid-cols-2" key={i}> */}
                        <div className="border-primary-blue text-primary-red border-b md:border-r-2 md:w-[400px] text-center p-2 text-lg font-bold">
                          {ip1}
                        </div>
                        <div className="border-primary-blue text-primary-red border-b  w-full  text-lg font-bold">
                          <input
                            type={type}
                            className="text-primary-blue w-full   p-2 outline-none "
                            {...register(`${name}`, {
                              required: false,
                              onChange: (e) => {
                                e.target.name === "company_capital" &&
                                  setAmount(e.target.value);
                              },
                            })}
                          />
                        </div>
                      </div>
                    );
                  })}
                  <div>
                    <div className="text-center border-t border-primary-blue p-2 font-bold text-primary-blue border-t-0 bg-red-200">
                      ट्रेडमार्क (ब्राण्ड) दर्ताको लागि तपाईको जम्मा लाग्ने रकम{" "}
                      <span className="text-red-500">रु.{totalAmount}।– </span> मात्र
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="border-primary-red text-primary-blue text-center w-fit rounded-full border-2 text-sm p-2 md:text-base">
            ट्रेडमार्क (ब्राण्ड) दर्ता गर्दा लाग्ने शुल्क सम्बन्धि पूर्ण जानकारी
            लिनको लागि यहाँ{" "}
            <span
              data-bs-toggle="modal"
              data-bs-target="#exampleModalEdit"
              className="text-primary-red cursor-pointer"
            >
              {" "}
              Click{" "}
            </span>{" "}
            गर्नुहोस
            <PrivateCompanyModal 
                 paymentRangeList={paymentRangeList} 
            />
          </div>
        </div>

        {/* <div className="mt-4">
          <div>
            <div>
              {Trademark_Registration_v3.map((item, i) => {
                const { name, validation, ip1, type } = item;
                console.log(item);
                return (
                  <div
                    key={i}
                    className="border-primary-blue flex flex-col md:flex-row"
                  >
                    <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      {ip1}
                    </div>
                    <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      <input type={type} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div> */}

        <p className="text-primary-blue font-Calistoga text-lg underline my-5">
          2. Details of Share Holders{" "}
          <span className="text-primary-blue font-Laila underline">
            {" "}
            (शेयर सदस्य तथा साँक्षीहरुको विवरण) (प्रा.लि. कम्पनीमा बढिमा १०१ जना
            सम्म सदस्य रहन सकिन्छ ।)
          </span>
        </p>

        <DetailsOfShareHolders
          DetailShareholder={TradeMark_details_of_shareholder}
          needed_share={trademark_shareholder}
          setShareHolders={setShareHolders}
          shareHolders={shareHolders}
        />

        {/* details of share holders open */}
        {/* <div className=""> */}
        {/* <div className="flex justify-end">
            <a className="add-record cursor-pointer" data-added={0}>
              <i className="">
                <svg
                  className="text-primary-blue h-8 w-8"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M16 2A14.172 14.172 0 0 0 2 16a14.172 14.172 0 0 0 14 14a14.172 14.172 0 0 0 14-14A14.172 14.172 0 0 0 16 2Zm8 15h-7v7h-2v-7H8v-2h7V8h2v7h7Z"
                  />
                  <path fill="none" d="M24 17h-7v7h-2v-7H8v-2h7V8h2v7h7v2z" />
                </svg>
              </i>
            </a>
          </div> */}
        {/* share holder details form */}
        {/* <div className="flex flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                <div className="min-w-[1300px] overflow-x-auto">
                  <div id="tbl_posts">
                    <div>
                      <div>
                        <div className="border-primary-blue  text-primary-red border text-lg font-bold">
                          क्र. स.
                        </div>
                        <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          शेयर सदस्यहरु वा साझेदार सदस्यहरुको नाम
                        </div>
                        <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          हालको ठेगाना
                        </div>
                        <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                          शेयर सदस्यको नागरीकता
                        </div>
                      </div>
                    </div>
                    <div id="tbl_posts_body">
                      <div id="rec-1" className="border-primary-blue border">
                        <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                          1
                        </div>
                        <div className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="file"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
        <div style={{ display: "none" }}>
          {/* div row add */}
          <div id="sample_table">
            <div>
              <div id="" className="border-primary-blue border">
                <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                  <span className="sn">1</span>
                </div>
                <div className="p-0">
                  <input
                    type="text"
                    name=""
                    className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                    id=""
                  />
                </div>
                <div className="p-0">
                  <input
                    type="text"
                    name=""
                    className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                    id=""
                  />
                </div>
                <div className="p-0">
                  <input
                    type="text"
                    name=""
                    className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                    id=""
                  />
                </div>
                <div className="p-0">
                  <input
                    type="file"
                    name=""
                    className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                    id=""
                  />
                </div>
                <div className="p-0">
                  <input
                    type="text"
                    name=""
                    className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                    id=""
                  />
                </div>
                <div className="p-0">
                  <input
                    type="text"
                    name=""
                    className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                    id=""
                  />
                </div>
                <div className="p-0">
                  <input
                    type="file"
                    name=""
                    className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                    id=""
                  />
                </div>
                <div className="">
                  <a href="" className="delete-record">
                    <svg
                      className="text-primary-red h-8 w-8"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="img"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M19.1 4.9C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0s4-10.3.1-14.2zm-4.3 11.3L12 13.4l-2.8 2.8l-1.4-1.4l2.8-2.8l-2.8-2.8l1.4-1.4l2.8 2.8l2.8-2.8l1.4 1.4l-2.8 2.8l2.8 2.8l-1.4 1.4z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* details of share holders close */}

        {/* upload documents open */}
        {/* <div>
          <div>
            <div>
              <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                S. N.
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Document Name
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Action
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Remarks
              </div>
            </div>
          </div>
          <div>
            {TradeMark_upload_details.map((item, index) => {
              return (
                <div className="border-primary-blue border">
                  <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                    {item.sn}
                  </div>
                  <div className="p-0">
                    <p className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none">
                      {item.ip1}
                      <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
                        Upload
                      </button>
                    </p>
                  </div>
                  <div className="p-0">
                    <div className="border-primary-blue text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                      <button className="bg-primary-green rounded-xl px-2 ">
                        view
                      </button>
                      <button className="bg-primary-red rounded-xl px-2">
                        Delete
                      </button>
                    </div>
                  </div>
                  <div className="p-0">
                    <div className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                      {item.remark}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}
        <p className="text-primary-blue font-Calistoga text-lg underline my-5">
          3. Upload Document{" "}
          <span className="text-primary-blue font-Laila underline">
            (ईक्जिम कोड दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु{" "}
            <span className="text-red-600">Upload</span> गर्नुहोस ।)
          </span>
        </p>
        <Documents
          documents_data={TradeMark_upload_details}
          initialState={data}
          setDocument={setDocsOutput}
        />
        {/* upload documents close */}
        <div className="text-primary-blue font-Calistoga my-3">
          4. Working Branch
          <span className="text-primary-blue underline text-base font-Laila mx-2">
            (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन
            शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
          </span>
        </div>

        <FormBranch register={register} />
        <FormButtom />
        <FormPayment
          handleSubmit={handleSubmit}
          handleClick={handleClick}
          setUploadProof={setUploadProof}
          totalAmount={totalAmount}
          dueAmount = {dueAmount}
          setPaidAmount = {setPaidAmount}

        />
      </form>
    </div>
  );
};

export default TradeMarkRegistration;
